import {makeStyles} from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    backgroundColor: "transparent",
    maxHeight: "calc(100vh - 350px) !important",
    overflowY: "auto",
    marginTop: "16px",
  },
}));

export default useStyles;